import React from 'react';

const TableComponent = ({ data }) => {
    if (!data || !data.headers || !data.rows) return null;

    return (
        <div className="mt-2 mb-4 overflow-hidden border border-[var(--border-subtle)]/50 rounded-xl shadow-sm bg-[var(--bg-secondary)]/50 max-w-full">
            <div className="overflow-x-auto custom-scrollbar max-h-[300px]">
                <table className="w-full text-left text-sm text-[var(--text-main)]">
                    <thead className="text-xs text-[var(--text-muted)] uppercase bg-[var(--bg-tertiary)]/80 sticky top-0 z-10 backdrop-blur-md">
                        <tr>
                            {data.headers.map((header, index) => (
                                <th key={index} scope="col" className="px-4 py-3 font-semibold whitespace-nowrap">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-[var(--border-subtle)]/30">
                        {data.rows.map((row, rowIndex) => (
                            <tr key={rowIndex} className="hover:bg-[var(--bg-tertiary)]/30 transition-colors">
                                {(row.cells || row).map((cell, cellIndex) => (
                                    <td key={cellIndex} className="px-4 py-2.5 whitespace-nowrap">
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableComponent;
